import axiosInstance from "services/AxiosInstance";
import { ResponseType, TQuestionnaireRequest } from "types";

export const postQuestionnaireRequestRejectService = async (
  questionnaireRequestId: string
): Promise<ResponseType<TQuestionnaireRequest>> => {
  const response = await axiosInstance.post(`questionnaire/request/${questionnaireRequestId}/rejection`);
  return response.data;
};
